import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  DialogActions,
  Typography,
} from "@mui/material";

const buttonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  whiteSpace: "nowrap",
};

const ResetPassword = ({ theme, resetPassword }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal((prev) => !prev);
  };

  const handleConfirm = async () => {
    await resetPassword();
    setOpenModal(false);
  };

  return (
    <>
      <Button
        onClick={handleModal}
        variant="outlined"
        theme={theme}
        fullWidth
        sx={buttonSx}
      >
        Reset password
      </Button>
      <Dialog open={openModal} onClose={handleModal} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 600 }}>Send reset email</DialogTitle>
        <DialogContent>
          <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary">
              This will email you a password reset link. Are you sure you want to
              continue?
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleModal} color="inherit" sx={buttonSx} theme={theme}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="primary"
            theme={theme}
            sx={buttonSx}
          >
            Send email
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ResetPassword;
